import { z } from 'zod';
/** Billing (v2.0, Phase 18) — thin internal ledger. Amounts in integer cents. */
export const PAYMENT_SOURCES = ['client', 'payer', 'adjustment'];
export const chargeCreateSchema = z.object({
    contactId: z.string().uuid(),
    amountCents: z.number().int().positive().max(100_000_00),
    description: z.string().max(200).optional(),
    cptCode: z.string().max(12).optional(),
    serviceDate: z.coerce.date().optional(),
});
// `reference` is a check #, ERA id, or receipt — NEVER a card/bank number.
// Reject anything that looks like a 13–19 digit PAN (ADR-0011 / prohibited-action rule).
const notPan = z
    .string()
    .max(60)
    .refine((s) => !/^\d{13,19}$/.test(s.replace(/[\s-]/g, '')), {
    message: 'Card/bank numbers must never be stored; use a check # or ERA id',
});
export const paymentCreateSchema = z.object({
    contactId: z.string().uuid(),
    amountCents: z.number().int().positive().max(100_000_00),
    source: z.enum(PAYMENT_SOURCES).default('client'),
    reference: notPan.optional(),
});
//# sourceMappingURL=billing.js.map